import VanillaCalendar from 'vanilla-calendar-pro';
// eslint-disable-next-line sort-imports
import 'vanilla-calendar-pro/build/vanilla-calendar.min.css';
export default class MultiStepForm {
    constructor() {
        this.steps = Array.from(document.querySelectorAll('.opk__step'));
        this.stepsInfo = Array.from(document.querySelectorAll('.opk__step-info'));
        this.btnNext = document.querySelectorAll('.j-button-next');
        this.btnPrev = document.querySelectorAll('.j-button-prev');
        this.btnSubmit = document.querySelector('.j-opk-form-submit');
        this.form = document.querySelector('form[data-validate]');
        this.formError = Array.from(document.querySelectorAll('.opk__form-error'));
        this.activeIndex = 0;
        this.apiUrl = '/api/opk/query';

        // Переменные для данных, которые нужно отправить
        this.formData = {
            phoneNumber: '',
            ddu        : '',
            inspect    : '',
            writeex    : ''
        };

        this.dates = {};

        this.init();
    }

    init() {
        this.attachEventListeners();
        this.updateStepsUI();
    }

    attachEventListeners() {
        // Навешиваем события на кнопки "Далее"
        this.btnNext.forEach((button) => {
            button.addEventListener('click', this.handleNextStep.bind(this));
        });

        // Навешиваем события на кнопки "Назад"
        this.btnPrev.forEach((button) => {
            button.addEventListener('click', this.handlePrevStep.bind(this));
        });

        // Сабмит формы при нажатии кнопки отправки
        this.btnSubmit?.addEventListener('click', this.handleSubmit.bind(this));
    }

    handleNextStep() {
        if (this.activeIndex === 0) {
            // Валидация первого шага и сохранение данных
            this.collectStep1Data();
            this.activeIndex++;
            this.updateStepsUI();
        } else if (this.activeIndex === 1) {
            this.btnNext.forEach((element) => {
                element.disabled = true;
            });
            this.collectStep2Data();
            this.sendInspectionData();
        }
    }

    handlePrevStep() {
        // Возврат на предыдущий шаг
        this.activeIndex--;
        if (this.activeIndex < 0) {
            this.activeIndex = 0;
        }
        this.updateStepsUI();
    }

    updateStepsUI() {
        // Обновляем видимость шагов
        this.steps.forEach((step, index) => {
            if (index === this.activeIndex) {
                step.classList.add('opk__step-active');
            } else {
                step.classList.remove('opk__step-active');
            }
        });

        // Обновляем прогресс-бар шагов
        this.stepsInfo.forEach((step, index) => {
            if (index === this.activeIndex) {
                step.classList.add('opk__step-info-active');
                step.scrollIntoView({
                    behavior: 'smooth',
                    block   : 'nearest',
                    inline  : 'center'
                });
            } else {
                step.classList.remove('opk__step-info-active');
            }
        });

        this.formError.forEach((el) => {
            el.innerText = '';
        });
    }

    collectStep1Data() {
        // Сбор данных с первого шага
        this.formData.phoneNumber = document.querySelector('#tel').value.trim();
        this.formData.ddu = document.querySelector('#ddu').value.trim();
    }

    collectStep2Data() {
        // Сбор данных со второго шага
        this.formData.inspect = document.querySelector('input[name="inspect"]:checked').value;
        this.formData.writeex = 'no';
    }

    sendInspectionData() {
        fetch(this.apiUrl, {
            method : 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.formData)
        })
            .then((response) => {
                this.btnNext.forEach((element) => {
                    element.disabled = false;
                });

                return response.json();
            })
            .then((data) => {
                if (data.status === '100') {
                    this.dates = data;

                    const dateInput = document.querySelector('#datepicker');
                    const timeSelect = document.querySelector('#time');

                    const calendarWrapper =
                        document.querySelector('.opk__calendar');

                    const enabledDates = Object.keys(this.dates.message).map((date) => {
                        const [day, month, year] = date.split('.');

                        return `${year}-${month}-${day}`;
                    });

                    this.initCalendar(dateInput,
                        timeSelect,
                        calendarWrapper,
                        enabledDates);

                    dateInput.addEventListener('click', () => {
                        calendarWrapper.style.display = 'block';
                    });

                    this.activeIndex++;
                    this.updateStepsUI();
                } else {
                    this.formError.forEach((el) => {
                        el.innerText = data.message;
                    });
                }
            })
            .catch((error) => {
                console.error('Ошибка:', error);
            });
    }

    initCalendar(dateInput, timeSelect, calendarWrapper, enabledDates) {
        const calendarOptions = {
            settings: {
                lang      : 'ru',
                visibility: {
                    theme: 'light'
                },
                range: {
                    disableAllDays: true,
                    enabled       : enabledDates
                }
            },
            actions: {
                clickDay: (event, self) => {
                    const [year, month, day] = self.selectedDates[0].split('-');
                    const chosenDay = `${day}.${month}.${year}`;

                    dateInput.value = chosenDay;
                    timeSelect.disabled = false;
                    calendarWrapper.style.display = 'none';
                    this.updateTimeSelect(chosenDay);
                }
            }
        };

        const calendar = new VanillaCalendar('#date', calendarOptions);

        calendar.init();
    }

    updateTimeSelect(selectedDate) {
        const timeSelect = document.querySelector('#time');

        timeSelect.innerHTML = '';

        const chosenDayData = this.dates.message[selectedDate];

        const availableTimesArr = Object.keys(chosenDayData) || [];

        availableTimesArr.forEach((time) => {
            const option = document.createElement('option');

            option.value = time;
            option.textContent = time;
            timeSelect.appendChild(option);
            this.updateManagerName(chosenDayData, time);
        });
    }

    updateManagerName(chosenDayData, selectedTime) {
        const managerInput = document.querySelector('#manager');

        const managerName = chosenDayData[selectedTime];

        managerInput.value = managerName;
    }

    handleSubmit(event) {
        event.preventDefault();
        this.btnSubmit.disabled = true;

        // Сбор данных с третьего шага
        const scheduleDate = `${document
            .querySelector('#datepicker')
            .value.split('.')
            .reverse()
            .join('')}${document
            .querySelector('#time')
            .value.split(':')
            .join('')}00`;

        const managerName = document.querySelector('#manager').value;

        this.formData.writeex = 'yes';
        this.formData.ScheduleDate = scheduleDate;
        this.formData.Manager = managerName;

        // Отправка всех данных на сервер
        fetch(this.apiUrl, {
            method : 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.formData)
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                if (data.status === '100') {
                    const successStep = document.querySelector('.opk__last-step-success');
                    const lastStep = document.querySelector('.opk__last-step');
                    const successTitle = document.querySelector('.opk__success-title');
                    const successDescription = document.querySelector('.opk__success-description');
                    const successAddress = document.querySelector('.opk__success-address');

                    lastStep.style.display = 'none';
                    successStep.style.display = 'block';

                    if (this.formData.inspect === 'person') {
                        successTitle.innerText =
                            'Вы записаны на осмотр объекта недвижимости';
                        successDescription.innerText =
                            // eslint-disable-next-line max-len
                            'Вам будет необходимо подойти к объекту недвижимости, там будет ожидать менеджер. На осмотр допускаются лица, с кем у застройщика заключен договор, либо лица с нотариально заверенной доверенностью.';
                    } else {
                        successTitle.innerText =
                            'Вы записаны на приемку объекта недвижимости без осмотра';
                        successDescription.innerText =
                            'Вам необходимо подойти в офис отдела передачи квартир';
                        successAddress.innerText = data.flat_address;
                    }
                } else {
                    this.formError.forEach((el) => {
                        el.innerText = data.message;
                    });
                }
            })
            .catch((error) => {
                console.error('Ошибка:', error);
            });
    }
}
